import { registerApplication, start } from "single-spa";

const ignoreCookieConsent = [
  "/www-pricing",
  "/www-cameras",
  "/free-account-register/webview",
  "/free-account-complete/webview",
  "/free-account-register/embed",
  "/free-account-complete/embed",
  "/capture-services-finder",
  "/auth/model-select",
];

registerApplication({
  name: "@mp/cookie-consent",
  app: () => System.import("@mp/cookie-consent"),
  activeWhen: ({ pathname }) => {
    return !ignoreCookieConsent.some((name) => pathname.startsWith(name));
  },
});

registerApplication({
  name: "@mp/model-select",
  app: () => System.import("@mp/model-select"),
  activeWhen: "/auth/model-select",
});

start({
  urlRerouteOnly: true,
});
